module.exports = __webpack_public_path__ + "static/img/bottom_bg_left.439b07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom_bg_left.png
// module id = 1v+4
// module chunks = 1